import { ACLContextState, ACLReducerAction, ACLReducerActions } from "./types"

export const initialState: ACLContextState = {
  opco: '',
  ACL: []
}

export function ACLReducer (state: ACLContextState, action: ACLReducerAction) {
  switch (action.type) {
    case ACLReducerActions.setACL:
      return action.payload

    case ACLReducerActions.clearACL:
      return initialState

    default:
      return state
  }
}
